import { render, staticRenderFns } from "./VideoShopProduct.vue?vue&type=template&id=db41e776&"
import script from "./VideoShopProduct.vue?vue&type=script&lang=js&"
export * from "./VideoShopProduct.vue?vue&type=script&lang=js&"
import style0 from "./VideoShopProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports